// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hrtopbar-inline-1 {
  display: flex;
  align-items: center;
  gap: 8px;
}

.hrtopbar-inline-2 {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.hrtopbar-inline-3 {
  cursor: pointer;
}

.hrtopbar-inline-4 {
  cursor: pointer;
}

.hrtopbar-inline-5 {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/HR/HrTopbar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".hrtopbar-inline-1 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.hrtopbar-inline-2 {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n}\n\n.hrtopbar-inline-3 {\n  cursor: pointer;\n}\n\n.hrtopbar-inline-4 {\n  cursor: pointer;\n}\n\n.hrtopbar-inline-5 {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
